module.exports = "Higher-Order Components\n\n- Reuse component logic\n\n- Function that takes a component, returns a new one"


//////////////////
// WEBPACK FOOTER
// ./src/slides/12_beyond_basics/notes_2.md
// module id = 1537
// module chunks = 0